module.exports = __webpack_public_path__ + "media/customizations/camelback/back-3b99b8ea6470640d48c4e7d9e8a5340f.jpg";